import React from "react";
import styled from "styled-components";
import Button from "../../buttons/Button";
import { IoClose } from "react-icons/io5";

const StyledTopBar = styled.div`
    height: 32px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const TopBar = ({ buttonColor, onClose }) => {
    return (
        <StyledTopBar>
            <Button
                height="32px"
                width="32px"
                buttonColor={buttonColor}
                icon={<IoClose style={{ fontSize: "26px" }} />}
                onClick={onClose}
            />
        </StyledTopBar>
    );
};

export default TopBar;
